import * as React from 'react';
import {BATCH_STAGE} from '../../Config/appConfig';

const btnSpinner = require('../../resource/img/button-loading.gif');

interface BatchActionButtonsProps {
    stage: string,
    clickClose: (e: React.MouseEvent<HTMLElement>) => void,
    clickReset: () => void,
    clickSubmit: () => void,
    loading: boolean
}

class BatchActionButtons extends React.Component <BatchActionButtonsProps, {}> {
    public render() {
        switch (this.props.stage) {
            case BATCH_STAGE.VALID:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickClose(e)} disabled={this.props.loading}>Cancel</button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickSubmit()} disabled={this.props.loading}>
                                <span className="cmBtnText">Submit</span>
                                {this.props.loading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                    </div>
                );
            case BATCH_STAGE.INVALID:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickClose(e)} disabled={this.props.loading}>Cancel</button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickReset()} disabled={this.props.loading}>Reset</button>
                        </div>
                    </div>
                );
            default:
                return (
                    <div />
                );
        }
    }
}

export default BatchActionButtons;



// WEBPACK FOOTER //
// ./src/Components/Batch/BatchActionButtons.tsx